import React, { useEffect, useState, Fragment, useContext } from 'react'
import { withRouter } from 'react-router-dom'
import AddIcon from '@material-ui/icons/Add'
import { makeStyles } from '@material-ui/core'
import { UserManagementWrapper } from 'Components/UserManagement/UserManagementWrapper'
import { ConfirmDialogV2 } from '../../Components/ConfirmDialogV2'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import {
  getUsers,
  getUserById,
  setFilterClient,
  setFilterStatus,
  setFilterRole,
  setUsersSortBy,
} from 'Reducers/Users/actions'
import { getClients } from 'Reducers/Clients/actions'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { deleteUser } from '../../Reducers/Users/actions'
import { showReduxModal } from '../../Reducers/UI/actions'
import UsersListTable from './UsersListTable'
import SubmitButton from 'Components/Form/SubmitButton'
import { DeleteIcon } from '../../Assets/Images/icons/DeleteIconV2'
import { SnackBarContext } from '../../Components/SnackBar'
import { PageTitle } from '../../Components/PageTitle/index'
import { handleConfirmationDialog } from '../City/Page/Ambasadors/EmailPipelineView/utils'
import StyledBreadcrumbs from '../../Components/StyledBreadcrumbs'
import { UserManagementIcon } from '../../Assets/Images/icons/UserManagementIcon'
import { PATHS } from '../../Config/Routing/paths'
import ArrowBackIcon from '../ClientSettings/icons/ArrowBackIcon'

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
    cursor: 'default',
    display: 'flex',
    fontWeight: 800,
  },
  addUser: {
    fontFamily: 'Proxima Nova, Helvetica, Arial, sans-serif',
  },
  back: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    marginRight: '12px',
  },
}))

const UserManagement = props => {
  const classes = useStyles()
  const { usersList, match, history, loggedUser } = props
  const { isVerified } = loggedUser

  const [confirmDialogData, setConfirmDialogData] = useState({ isOpen: false })
  const runSnackBar = useContext(SnackBarContext)

  useEffect(() => {
    props.getUsers()
    props.getClients()
  }, [])

  const deleteUserById = async (id, user) => {
    await props.deleteUser(id)
    runSnackBar({
      type: 'other',
      msg: `User ${user.firstName || ''} ${user.lastName ||
        ''} successfully deleted`,
      icon: <DeleteIcon />,
      horizontal: 'right',
      vertical: 'top',
      newDesign: true,
    })
    props.getUsers()
    props.getClients()
  }

  const deleteUserByIdConfirmation = id => {
    const user = props.usersList.find(u => u.id === id)

    handleConfirmationDialog({
      title: `Delete user?`,
      contentText: (
        <span cypress_id={'modalBody'}>
          Are you sure you want to delete User{' '}
          <b>
            {user.firstName} {user.lastName}
          </b>
          ?
        </span>
      ),
      setConfirmDialogData,
      hasOptions: true,
      rightButtonLable: 'Delete',
      leftButtonLable: 'Cancel',
      onConfirm: () => deleteUserById(id, user),
    })
  }

  const onBack = () => {
    history.push(`${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`)
  }

  return (
    <HideWhenBlocked>
      <UserManagementWrapper
        className="UserManagementWrapper"
        style={{
          backgroundColor: '#f9f9ff',
          height: 'calc(100vh - 72px)',
          padding: '20px 35px 20px 40px',
        }}
      >
        {confirmDialogData.isOpen && <ConfirmDialogV2 {...confirmDialogData} />}
        <StyledBreadcrumbs
          icon={<UserManagementIcon />}
          breadcrumbs={[
            {
              label: 'User Management',
            },
          ]}
        />
        <div className="user-container">
          <PageTitle className={classes.title}>
            <div className={classes.back} onClick={onBack}>
              <ArrowBackIcon />
            </div>
            <div className="title-user-management">User Management</div>
          </PageTitle>
          <div className="add-user-wrapper">
            <SubmitButton
              value={
                <Fragment>
                  <AddIcon fontSize="small" />
                  <span className={classes.addUser}>Add user</span>
                </Fragment>
              }
              className="add-user"
              onClick={e => {
                e.stopPropagation()
                if (isVerified) {
                  history.push(`${props.match.url}/create`)
                } else {
                  runSnackBar({
                    type: 'error',
                    vertical: 'top',
                    msg: 'Verify your email to add users',
                  })
                }
              }}
            />
          </div>
        </div>
        <div className="table-wrapper">
          <UsersListTable
            match={match}
            usersList={usersList}
            history={history}
            handleUserDelete={deleteUserByIdConfirmation}
            showPages={false}
          />
        </div>
      </UserManagementWrapper>
    </HideWhenBlocked>
  )
}

UserManagement.propTypes = {
  usersList: PropTypes.array,
  getUsers: PropTypes.func.isRequired,
  getClients: PropTypes.func.isRequired,
  getUserById: PropTypes.func.isRequired,
  setFilterClient: PropTypes.func.isRequired,
  setFilterStatus: PropTypes.func.isRequired,
  setFilterRole: PropTypes.func.isRequired,
  filterClient: PropTypes.string,
  filterStatus: PropTypes.string,

  setUsersSortBy: PropTypes.func.isRequired,
}

const mapStateToProps = ({ users, clients }) => ({
  usersList: users.users,
  clientsList: clients.clientsList,
  filterClient: users.filterClient,
  filterStatus: users.filterStatus,
  filterRole: users.filterRole,
  sortBy: users.usersSortBy,
  loggedUser: users.loggedUser,
})

export default connect(
  mapStateToProps,
  {
    getUsers,
    getClients,
    getUserById,
    setFilterClient,
    setFilterStatus,
    setFilterRole,
    setUsersSortBy,
    deleteUser,
    showReduxModal,
  },
)(withRouter(UserManagement))
